<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title" style="margin-bottom:20px;">
                                    <span>Add Contact</span>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>

                                <form method="post" enctype="multipart/form-data" @submit.prevent="submitForm" class="form-check" :class="{isTpg:isTpg}" name="zone_form" style="margin-bottom: 0px;height:auto;min-height:auto;">
                                    <div class="onboarding-container" style="margin-bottom: 0px;height:auto;min-height:auto;">
                                        <!-- <div class="alert alert-danger" role="alert" v-html="errorString" v-if="errorString" style="margin-bottom: 20px;">

                                        </div> -->

                                        <reload-page v-if="showReload" :showReloadMessage="showReloadMessage" style="margin-top:50px;" id="reload-component"></reload-page>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4">
                                                Name (<span :class="{inlineError:v$.first_name.$error,isTpg:isTpg}">First</span>,<span :class="{inlineError:v$.last_name.$error,isTpg:isTpg}">Last</span>):
                                            </div>
                                            <div class="col-lg-8">
                                                <div class="">
                                                    <div class="col-xs-6" style="padding:0px;padding-right:3px;">
                                                        <input name="First Name" type="text" v-model="first_name" data-firstname>
                                                    </div>
                                                    <div class="col-xs-6" style="padding:0px;padding-left:3px;">
                                                        <input type="text" name="Last Name" v-model="last_name" data-lastname>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4">
                                                <span :class="{inlineError:v$.email.$error,isTpg:isTpg}">Email:</span>
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="Email" v-model="email" data-email>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-4">
                                                <span :class="{inlineError:v$.phone.$error,isTpg:isTpg}">Phone:</span>
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="Phone" v-model="phone" data-phone>
                                            </div>
                                        </div>

                                        <div style="width:100%;text-align: center;margin-top:40px;margin-bottom:20px">
                                            <button class="clean-grayv form-submit-button" type="submit" style="width:300px;margin-bottom:0px" :disabled="formHasBeenSubmitted">Submit</button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import useVuelidate from '@vuelidate/core';
import {
  required, helpers, requiredIf, minLength, email,
} from '@vuelidate/validators';

const Querystring = require('querystring');

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  props: ['is-tpg', 'category-id', 'user-info', 'location-id', 'account-id'],
  data() {
    return {
      showReload: false,
      showReloadMessage: '',
      errorString: '',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      formHasBeenSubmitted: false,
    };
  },
  mounted() {},
  validations() {
    return {
      first_name: { required: helpers.withMessage('First name is required', required) },
      last_name: { required: helpers.withMessage('Last name is required', required) },
      email: { required: helpers.withMessage('Email is required', required, email) },
      phone: {
        minLength: minLength(10),
        required: helpers.withMessage('Phone number must be at least 10 digits', requiredIf(function () {
          return (this.phone.length > 0);
        })),
      },
    };
  },
  methods: {
    setAccountId() {
      // return the first id in accounts node
      if (this.userInfo && this.userInfo.accounts) {
        for (const k in this.userInfo.accounts) {
          if (Object.prototype.hasOwnProperty.call(this.userInfo.accounts, k)) {
            this.account_id = k;
            return;
          }
        }

        if (!this.account_id || this.accountId) {
          this.showReload = true;
          this.showReloadMessage = 'ACM1: Error setting account identifier';
        }
      }
    },
    show() {
      this.clearInfo();
    },
    // cancel: function() {
    //     this.clearInfo();
    //     $('#modalContacts').modal('hide');
    // },
    submitForm() {
      this.formHasBeenSubmitted = true;
      this.v$.$validate();
      this.errorString = '';

      // Check validation
      if (this.v$.$error) {
        this.formHasBeenSubmitted = false;
        const errors = this.v$.$errors;
        let errorList = "<b>Errors</b><ul style='text-align:left'>";
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        this.errorString = errorList;
        this.$wkToast(errorList);
      } else {
        // Make sure phone has 10 digits
        if (this.phone.length > 0 && !this.isTenDigits(this.phone)) {
          this.formHasBeenSubmitted = false;
          let errorList = "<b>Errors</b><ul style='text-align:left'>";
          errorList += '<li>Phone number must contain 10 digits</li>';
          errorList += '</ul>';
          this.errorString = errorList;
          this.$wkToast(errorList);

          return;
        }

        this.saveContact();
      }
    },
    isTenDigits(string) {
      if (/^\D*(\d\D*){10}$/.test(string)) {
        return true;
      }
    },
    saveContact() {
      // TODO: check all params before send
      const contact = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        'phones[0][number]': this.phone,
        'phones[0][type]': 'main',
        'relations[0][type]': 'Location',
        'relations[0][id]': this.locationId,
      };
      const contactQueryString = Querystring.stringify(contact);

      const self = this;
      this.$http.post('/v2/contact', contactQueryString).then((response) => {
        if (response.data.error == true) {
          console.log('error');
          self.formHasBeenSubmitted = false;
          self.errorString = self.returnFriendlyErrors(response);
          self.$wkToast(self.returnValidatorErrors(self.errorString));
        } else {
          // Successful POST
          self.formHasBeenSubmitted = false;
          contact.id = response.data.data.contact.id;
          contact.category_id = self.categoryId;
          self.$emit('addContact', contact);
          self.$emit('close');
        }
      },
      (response) => {
        self.formHasBeenSubmitted = false;
        self.errorString = response.message;
        self.$wkToast(self.errorString);
      }).catch((response) => {
        if (response && response.data) {
          self.formHasBeenSubmitted = false;
          self.errorString = self.returnFriendlyErrors(response);
          self.$wkToast(self.errorString);
        }
      });
    },
    returnFriendlyErrors(response) {
      if (response && response.data && (response.error == 'Unauthenticated.' || response.data.error == 'Unauthenticated')) {
        window.location.reload();
      }

      let errorString = '';
      if (response) {
        if (response.data) {
          errorString += this.parseDataKeys(response.data.fields);
        }
        if (response.message) {
          errorString += response.data.message;
        }
      }

      return errorString;
    },
    clearInfo() {
      this.first_name = '';
      this.last_name = '';
      this.email = '';
      this.phone = '';
      this.errorString = '';
      this.showReload = false;
      this.showReloadMessage = '';
      this.formHasBeenSubmitted = false;
    },
  },
  watch: {
    userInfo() {
      // this.setAccountId();
    },
  },
};
</script>

<style scoped>
.modal-dialog {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    margin-top: 50px;
}

.modal-content {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    background: #666;
    color: white;
}

.onboarding-container {
    text-align: left;
}

.onboarding-container input[type="text"] {
    border: 0px solid #ccc;
    background: #fff;
    color: #000;
    border-radius: 5px;
    width: 100%;
    height: 36px;
    font-weight: normal;
}

.close-modal.isTpg {
    color: black;
}

.close-modal {
    position: absolute;
    top: 0px;
    right: 10px;
    cursor: pointer;
    text-align: right;
    width: 20px;
    height: 20px;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}
</style>
